(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const keyBenefitsLogic =
      document.querySelector('facets-form-component[data-key-benefits-logic]')?.dataset.keyBenefitsLogic || 'and';
    const enableCategoryMultiselect =
      document.querySelector('facets-form-component[data-enable-category-multiselect]')?.dataset.enableCategoryMultiselect !== 'false';

    const clearFilterParamFromUrl = (paramName) => {
      const url = new URL(window.location.href);
      url.searchParams.delete(paramName);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    };

    const navigateToCollectionTags = (collectionUrl, tagHandles) => {
      const baseUrl = new URL(collectionUrl, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);

      currentParams.delete('page');
      currentParams.delete('filter.p.tag');

      const normalizedPath = baseUrl.pathname.replace(/\/+$/, '');
      const uniqueHandles = Array.from(new Set(tagHandles.filter(Boolean)));
      const tagsPath = uniqueHandles.length ? `/${uniqueHandles.join('+')}` : '';

      baseUrl.pathname = `${normalizedPath}${tagsPath}`;
      baseUrl.search = currentParams.toString();

      window.location.assign(baseUrl.toString());
    };

    const handleBenefitCheckboxChange = (target, event) => {
      if (!(target instanceof HTMLInputElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const changedTagHandle = target.dataset.tagHandle || '';
      const allBenefitInputs = Array.from(document.querySelectorAll('.collection-benefit__checkbox')).filter(
        (input) => input instanceof HTMLInputElement
      );

      allBenefitInputs.forEach((input) => {
        if (input.dataset.tagHandle === changedTagHandle) {
          input.checked = target.checked;
        }
      });

      if (keyBenefitsLogic === 'or' && target.checked) {
        allBenefitInputs.forEach((input) => {
          if (input.dataset.tagHandle !== changedTagHandle) {
            input.checked = false;
          }
        });
      }

      const checkedTagHandles = Array.from(
        new Set(
          allBenefitInputs
            .filter((input) => input.checked)
            .map((input) => input.dataset.tagHandle || '')
            .filter(Boolean)
        )
      );

      navigateToCollectionTags(target.dataset.collectionUrl || '/collections/all', checkedTagHandles);
    };

    const handleBenefitShowAllChange = (target, event) => {
      if (!(target instanceof HTMLInputElement)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (!target.disabled) {
        navigateToCollectionTags(target.dataset.collectionUrl || '/collections/all', []);
      }
    };

    const bindCustomBenefitControls = () => {
      document.querySelectorAll('.collection-benefit__checkbox').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        if (input.dataset.boundBenefit === 'true') return;

        input.addEventListener('change', (event) => handleBenefitCheckboxChange(input, event));
        input.dataset.boundBenefit = 'true';
      });

      document
        .querySelectorAll('.collection-filter__show-all-input[data-clear-param="filter.p.tag"]')
        .forEach((input) => {
          if (!(input instanceof HTMLInputElement)) return;
          if (input.dataset.boundBenefitShowAll === 'true') return;

          input.addEventListener('change', (event) => handleBenefitShowAllChange(input, event));
          input.dataset.boundBenefitShowAll = 'true';
        });
    };

    const syncCustomFacetCheckboxes = () => {
      const params = new URLSearchParams(window.location.search);

      document.querySelectorAll('input[name="filter.p.product_type"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;

        const selected = params.getAll(input.name);
        input.checked = selected.includes(input.value);
      });
    };

    const syncCustomShowAllButtons = () => {
      document.querySelectorAll('.collection-filter__show-all-input[data-clear-param]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;

        const clearParam = input.dataset.clearParam;
        if (!clearParam) return;

        const hasActiveValues =
          clearParam === 'filter.p.tag'
            ? Array.from(document.querySelectorAll('.collection-benefit__checkbox')).some(
                (facetInput) => facetInput instanceof HTMLInputElement && facetInput.checked
              )
            : Array.from(document.querySelectorAll(`input[name="${clearParam}"]`)).some(
                (facetInput) => facetInput instanceof HTMLInputElement && facetInput.checked
              );

        input.checked = !hasActiveValues;
        input.disabled = !hasActiveValues;
        input.setAttribute('aria-disabled', String(!hasActiveValues));

        const wrapper = input.closest('.collection-filter__show-all-wrapper');
        if (wrapper instanceof HTMLElement) {
          wrapper.classList.toggle('checkbox--disabled', !hasActiveValues);
        }
      });
    };

    const preserveQueryParams = (targetUrl) => {
      const url = new URL(targetUrl, window.location.origin);
      const params = new URLSearchParams(window.location.search);
      params.delete('page');

      // Preserve collection tag path segments if present
      const currentPath = window.location.pathname;
      const match = currentPath.match(/\/collections\/([^/]+)\/(.+)/);
      if (match && match[2]) {
        url.pathname = url.pathname.replace(/\/+$/, '') + '/' + match[2];
      }

      url.search = params.toString();
      window.location.assign(url.toString());
    };

    const syncManualAvailabilityCheckboxes = () => {
      const params = new URLSearchParams(window.location.search);

      document.querySelectorAll('input[name="filter.v.availability"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;

        const selected = params.getAll(input.name);
        input.checked = selected.includes(input.value);
      });
    };

    const bindCategoryControls = () => {
      if (enableCategoryMultiselect) return;
      document.querySelectorAll('input[name="filter.p.product_type"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement)) return;
        if (input.dataset.boundCategory === 'true') return;

        input.addEventListener('change', () => {
          if (input.checked) {
            document.querySelectorAll('input[name="filter.p.product_type"]').forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.checked = false;
              }
            });
          }
        });
        input.dataset.boundCategory = 'true';
      });
    };

    window.syncCustomFacetCheckboxes = syncCustomFacetCheckboxes;
    window.syncManualAvailabilityCheckboxes = syncManualAvailabilityCheckboxes;
    window.syncCustomShowAllButtons = syncCustomShowAllButtons;

    syncCustomFacetCheckboxes();
    syncManualAvailabilityCheckboxes();
    syncCustomShowAllButtons();
    bindCustomBenefitControls();
    bindCategoryControls();

    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;

      if (event.target.classList.contains('collection-benefit__checkbox')) {
        handleBenefitCheckboxChange(event.target, event);
        return;
      }

      if (event.target.classList.contains('collection-filter__show-all-input')) {
        const clearParam = event.target.dataset.clearParam;
        if (clearParam) {
          event.preventDefault();
          event.stopImmediatePropagation();

          if (!event.target.disabled) {
            if (clearParam === 'filter.p.tag') {
              handleBenefitShowAllChange(event.target, event);
            } else {
              clearFilterParamFromUrl(clearParam);
            }
          }
        }

        return;
      }

      if (!event.target.classList.contains('collection-category__checkbox')) return;

      event.stopImmediatePropagation();

      if (event.target.checked) {
        preserveQueryParams(event.target.dataset.collectionUrl || '/collections/all');
      } else {
        preserveQueryParams('/collections/all');
      }
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('.collection-category__show-all') : null;
      if (!(trigger instanceof HTMLElement)) return;

      event.preventDefault();
      preserveQueryParams(trigger.dataset.collectionUrl || '/collections/all');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
